import { Tooltip } from "@mui/material";
import styles from "./m3.module.css";

const TONE_CLASS = {
  neutral: styles.chipNeutral,
  primary: styles.chipPrimary,
  tertiary: styles.chipTertiary,
  success: styles.chipSuccess,
  warning: styles.chipWarning,
  error: styles.chipError,
  info: styles.chipInfo,
};

/**
 * Small label chip (M3 assist/input chip look).
 *
 * @param {"neutral"|"primary"|"tertiary"|"success"|"warning"|"error"|"info"} tone
 * @param {"sm"|"md"} size
 * @param {string} tooltip
 */
const Chip = ({ children, icon, tone = "neutral", size = "md", tooltip, onClick, className = "" }) => {
  const chip = (
    <span
      className={`${styles.chip} ${TONE_CLASS[tone] || styles.chipNeutral} ${size === "sm" ? styles.chipSm : ""} ${onClick ? styles.chipClickable : ""} ${className}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {icon}
      {children}
    </span>
  );
  return tooltip ? (
    <Tooltip title={tooltip} arrow placement="top">
      {chip}
    </Tooltip>
  ) : (
    chip
  );
};

export default Chip;
